import { render, staticRenderFns } from "./ComparisonViewer.vue?vue&type=template&id=157a498c&scoped=true"
import script from "./ComparisonViewer.vue?vue&type=script&lang=js"
export * from "./ComparisonViewer.vue?vue&type=script&lang=js"
import style0 from "./ComparisonViewer.vue?vue&type=style&index=0&id=157a498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a498c",
  null
  
)

export default component.exports